/*@ngInject*/
const UIAutoCloseDirective = function ($timeout, $document) {

    let linkFunction = function ($scope, $elm) {

        let timeoutList = [],
            isOpenClick = true;

        function onClick(event) {
            if (!isOpenClick) {
                let isClickedElementChildOfPopup = $elm.find(event.target).length > 0;

                if (!isClickedElementChildOfPopup && $scope.isOpen) {
                    timeoutList.push($timeout(function () {
                        $scope.onClose();
                        isOpenClick = true;
                    }));
                }
            }
            isOpenClick = !$scope.isOpen;
        }

        $document.bind('click', onClick);

        $scope.$on('$destroy', function () {
            $document.unbind('click', onClick);
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        link: linkFunction,
        restrict: 'A',
        scope: {
            onClose: '&',
            isOpen: '<'
        }
    };
};

angular.module('umCore')
    .directive('uiAutoClose', UIAutoCloseDirective);
